import constate from "constate";
import { type Dispatch, type SetStateAction, useMemo, useState } from "react";

const setOverlays = (setter: Dispatch<SetStateAction<HTMLDivElement | null>>) => {
  return (value: HTMLDivElement | null) => {
    if (value === null || value instanceof HTMLDivElement) {
      setter(value);
    }
  };
};

const useOverlays = () => {
  const [pageOverlays, setPageOverlays] = useState<HTMLDivElement | null>(null);
  const pageOverlaysSetter = useMemo(() => setOverlays(setPageOverlays), []);

  const store = useMemo(
    () => ({
      actions: { setPageOverlays: pageOverlaysSetter },
      state: { pageOverlays },
    }),
    [pageOverlays, pageOverlaysSetter],
  );

  return store;
};

const [OverlaysProvider, useOverlaysContext, usePageOverlays] = constate(
  useOverlays,
  (value) => value,
  ({ state: { pageOverlays } }) => pageOverlays,
);

export { OverlaysProvider, useOverlaysContext, usePageOverlays };
